import IndicatorAccordion from "../IndicatorAccordion";
import IndustrialCurrent from "../IndicatorIndustrialHisto/IndustrialCurrent";

const FormuleAnalytiqueRightPanel = () => (
  <div className="block rounded border border-gray-200 bg-white dark:border-gray-600 dark:bg-gray-800 ">
    <IndicatorAccordion label={"Paramètres"} composant={<IndustrialCurrent time={true} />} />
  </div>
);
export default FormuleAnalytiqueRightPanel;
